import { Entity, PrimaryGeneratedColumn, Column, ManyToOne } from 'typeorm'
import { PaygUser } from './PaygUser'

@Entity()
export class PaygVerificationToken {
  @PrimaryGeneratedColumn({ name: "id" })
  id?: number

  @Column({ nullable: false})
  token?: string

  @Column({ nullable: false})
  expires?: Date

  @ManyToOne(() => PaygUser, user => user.verificationTokens)
  user!: PaygUser
}
